export const getRoomPage = state => state.roomsReducer.list

export const getRoomPageLoading = state => state.roomsReducer.loading